export default __webpack_public_path__ + "static/grid3-f57de53110a4f88b527435a57dea060f.svg";